/* unplugin-vue-components disabled */import { render } from "./PlatformCardSelectable.vue?vue&type=template&id=5fcaddfa&scoped=true&ts=true"
import script from "./PlatformCardSelectable.vue?vue&type=script&lang=ts"
export * from "./PlatformCardSelectable.vue?vue&type=script&lang=ts"

import "./PlatformCardSelectable.vue?vue&type=style&index=0&id=5fcaddfa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fcaddfa"]])

export default __exports__